import { login, logout, getInfo } from '@/api/user';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { resetRouter } from '@/router';
const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    company_id: '',
    company: null,
    abilities: null,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    removeToken();
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_COMPANY: (state, company) => {
    state.company = company;
    state.company_id = company.id;
  },
  setCompanyId: (state, payload) => {
    state.company_id = payload;
  },
  setAbilities: (state, payload) => {
    if (typeof payload === 'string') {
      payload = JSON.parse(payload);
    }
    state.abilities = payload;
  },
};

const actions = {
  async login({ commit }, userInfo) {
    const { username, email, password } = userInfo;
    try {
      const data = await login({ email, password });
      commit('SET_TOKEN', data.token);
      setToken(data.token);
    } catch (error) {
      return error;
    }
  },

  async getInfo({ commit, state }) {
    try {
      const data = await getInfo(state.token);
      if (!data) return 'Verification failed, please Login again.';
      commit('SET_NAME', data.user.name);
      commit('SET_ROLES', data.roles);
      commit('setAbilities', data.abilities);
      commit('variable/setRoleLabel', data.roleLabel, { root: true });
      commit('variable/setUserRoleLabel', data.roleLabel, { root: true });
      commit('variable/setCompanies', data.companies, { root: true });
      if (data.company) {
        commit('SET_COMPANY', data.company);
      }
      return data;
    } catch (error) {
      return error;
    }
  },

  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      resetRouter();
      commit('RESET_STATE');
      resolve();
      logout(state.token)
        .then((res) => {
          // console.log(`[store/modules/user.js] [logout] res: ${JSON.stringify(res)}`)
          removeToken();
        })
        .catch((error) => {
          // console.log(`[store/modules/user.js] [logout] error: ${JSON.stringify(error)}`)
          reject(error);
        });
    });
  },

  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_STATE');
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
